<template>
  <div class="container">
    <vue-element-loading :active="isActive" spinner="spinner" color="#FF6700" background-color="rgba(0, 0, 0, .2)"/>
    <!-- 填写保修单 -->
      <div class="box">
    <div class="write-info">
      <div class="write-info-row-1" @click="handleChooseGoPage" >
        <span>网吧</span>
        <input v-reset-page  type="text" placeholder="请选择" :value="siteName" disabled  />
      </div>
      <div class="write-info-row-2">
        <span>联系人</span>
        <input v-reset-page  type="text" placeholder="请输入" v-model="userName" />
      </div>
      <div class="write-info-row-3">
        <span>联系电话</span>
        <input v-reset-page  type="number" placeholder="请输入"  oninput="if(value.length>11)value=value.slice(0,11)"
          pattern="[0-9]*"  v-model="phone" />
      </div>
    </div>
    <!-- 网吧信息 -->
    <div class="write-info2">
      <div class="write-info-row-1">
        <span>巡检时间</span>
        <input v-reset-page  type="text" placeholder="请输入" :value="date | formatDateTime" disabled />
      </div>
      <div class="write-info-row-2"> 
         <span>巡检位置</span>
         <span class="city-detail">{{city}}</span>
        <!-- <input v-reset-page  type="text" placeholder="请输入" :value="city" disabled /> -->
    
         <!-- <textarea name="" id="" cols="30" rows="10" :value="city" disabled></textarea> -->
      </div>
    </div>
    <!-- 保修描述 -->
    <div class="write-info3">
      <div class="title">巡检情况</div>
      <div class="textarea">
        <textarea v-reset-page  name id cols="30" rows="10" placeholder="您可以在此描述报修内容" v-model="description"></textarea>
      </div>
      <div class="title">
        上传图片
        <span class="prompt">（最多9张）</span>
      </div>
      <div class="uploader-image">
        <van-uploader
          :after-read="afterRead"
          :before-delete="beforeDelete"
          v-model="fileList"
          multiple
          :max-count="9"
          :preview-size="60"
          @click-preview="clickPreview"
          @close-preview="closePreview"
        />
      </div>
    </div>
    <!-- 提交按钮 -->
    <div class="plbm-btn" @click="isLoadingClick && handleSubmitClick()">提交</div>
    </div>
    <!-- 保修类型选择 -->
    <!-- <div class="loading">
            <van-loading color="#1989fa" style="display:block" />   
    </div> -->
       <van-loading color="#008cff" v-show="isLoadingShow"/>
    <!-- <van-loading color="#1989fa" type="spinner" v-show="isShowLoading"/> -->
  </div>
  
</template>
<script>
import { Uploader } from "vant";
import { Toast } from "vant";
import {inspectionSave} from "@/api/inspection";
import { UploadFile } from "@/api/public";
import axios from "axios";
import Exif from "exif-js";
import { Loading } from 'vant';
import VueElementLoading from 'vue-element-loading';
import wx from "weixin-js-sdk";
import { RichScan } from "@/api/index";
export default {
  components: {
    vanUploader: Uploader,
    vanLoading: Loading,
    VueElementLoading,
     vanLoading:Loading
  },
  data() {
    return {
      fileList: [],
      uploadImagePathList: [],
      columns: [],
      //   isSelectTypeShow:false,
      statusShow: false,
      siteName: "",
      userName: "",
      phone: "",
      typeName: "",
      maintenanceTypeId: "",
      description: "",
      arr: "",
      id: "",
      date: "",
      latitude: "",
      longitude: "",
      city: "获取位置中...",
      location:'',
      isShowLoading:false,
      isActive:false,
      isLoadingShow:false,
      isLoadingClick:true
    };
  },
  // 过滤器
  filters: {
    formatDateTime(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  mounted() {
    console.log(wx)
    this.requestGetWxLocation();
    console.log(this.$route.query);
    // 获取选择网吧页面的值
    this.id = this.$route.query.id;
    this.siteName = this.$route.query.siteName;
    // 获取当前时间
    this.date = new Date();

      if (window.history && window.history.pushState) {
      window.addEventListener("popstate", this.closePreview, false); //false阻止默认事件
    }
  },
     destroyed(){
     window.removeEventListener('popstate', this.closePreview, false);//false阻止默认事件
   },
  methods: {
        clickPreview() {
        history.pushState(null, null, document.URL);
    },
    closePreview() {
        console.log('关闭了')
    },
    afterRead(file) {
      // console.log(file);
      // this.requestUploadFile(file.content);
          console.log("length = " + file.length);
      console.log("fileList" + file);
      console.log("店家");
      let fileArray = [];
      if (file.length > 1) {
        fileArray = file;
      } else {
        fileArray.push(file);
      }

      let that = this;
      that.isActive = true;
      fileArray.forEach(imageFile => {
        console.log("店家:" + imageFile);
        let formData = new window.FormData();
        this.$utils.compress(imageFile.file, 0.5, function(err, data) {
          if (err) {
            console.log(err);
            return;
          }
          formData.append("file", data);

          let config = {
              headers: {'Content-Type': 'multipart/form-data'}
          }
          // console.log(formData)
          // HTUploadFile({formData}).then(res =>{
          //     console.log(res)
          // });
          // 添加请求头
          // let baseUrl = this.$utils.getBaseUrl();
          
           axios.post('https://kf.qingruilin.com.cn/netbar/api/common/v1/pic_upload', formData, config)
           .then(response => {
             let res = response.data;
             console.log(res.data)
             if(res.code == 200){
               console.log("地址:"+res.data.relativePicPath);
              //  that.arr += res.data.relativePicPath + ','
              that.uploadImagePathList.push(res.data.relativePicPath);
              that.isActive = false;
             }
           })
        });
      });
    },
    beforeDelete(index) {
      this.uploadImagePathList.splice(index, 1);
      return true;
    },
    // 获取微信中坐标地理位置
     requestGetWxLocation() {
       let href = location.href.split("#")[0];
       RichScan({url:href}).then(res=>{
          let that = this
          console.log(res)
        if (res.code == 200) {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端//alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ["getLocation"] // 必填，需要使用的JS接口列表
          });
          wx.ready(function(){

            wx.getLocation({
                type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                success: function (res) {
                  that.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                  that.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                  that.getMyLocation();
                }
            });
      });
        }
       })
     },
    // 点击或取网吧列表
    handleChooseGoPage() {
      this.$router.push({
        path: "/searchinternetcafes"
      });
    },
    // 获取当前位置信息
    getMyLocation() {
      let geolocation = new qq.maps.Geolocation("YEQBZ-KHBK5-UXEIE-QYYJ7-YEVP7-VKBRG","myapp");
      let options = { timeout: 8000 };
      geolocation.getLocation(this.showPosition, this.showErr, options);
    },
    showPosition() {
      var that = this                   
      let geocoder = new qq.maps.Geocoder({
       complete:function(result) {
          console.log(result)
          that.city = result.detail.addressComponents.city +  result.detail.nearPois[1].name
       }
     })
      var coord =new qq.maps.LatLng(that.latitude,that.longitude);
       geocoder.getAddress(coord);
    },
    showErr() {
      console.log("定位失败");
    },
    // 点击保存
    requestInspectionSave() {
       let internetBarId = this.id
       let siteName = this.siteName
       let userName = this.userName
       let phone = this.phone 
       let date = this.date
       let city = this.city
       let description =this.description
       let arr = this.uploadImagePathList.join(",");
       if(!siteName) {
           Toast("请输入网吧名称")
           return false
       }
      if(!userName) {
          Toast("请输入联系人")
          return false
       }
      if(!phone) {
          Toast("请输入手机号")
          return false
        }
      if(!description) {
         Toast("请输入巡检情况")
          return false
      }
      // if(!arr) {
      //    Toast("请上传照片")
      //    return false
      // }
    
      this.isLoadingShow = true
      if(this.isLoadingShow) {
          this.isLoadingClick = false
        }else {
          this.isLoadingClick = true 
        }
      inspectionSave({
        internetBarId:internetBarId,
        siteName:siteName,
        name:userName,
        phone:phone,
        inspectionDate:date,
        inspectionAddress:city,
        description:description,
        pictureUrl: arr
      }).then(res => {
        console.log(res);
        if(res.code == 200) {
            this.$router.push({
              path:'/inspectionrecords'
            })
        }
      });
    },
    // 上传文件
    async requestUploadFile(base64Img) {
      UploadFile({ base64Img: base64Img }).then(res => {
        console.log(res);
        this.arr += res.data + ",";
      });
    },
    // 提交
    handleSubmitClick() {
      this.requestInspectionSave();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  position:static;
    .box {
      height:calc(100vh + 1px);
      // 第一个模块
      .write-info {
        width: 375px;
        height: 159px;
        padding: 0 13px;
        box-sizing: border-box;
        background-color: #ffffff;
        text-align: left;
        color: #333333;
        font-size: 15px;
        margin-top: 10px;
        border-bottom: 1px solid #f2f2f2;
        .write-info-row-1 {
          width: 100%;
          height: 50px;
          padding-top: 15px;
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;
          input {
            display: inline-block;
            border: none;
            width: 210px;
            margin-left: 60px;
            &::-webkit-input-placeholder {
              color: #cccccc;
              font-size: 16px;
              box-sizing: border-box;
              padding-top: 3px;
            }
            &:disabled {
              background-color: #ffffff;
            }
          }
        }
        .write-info-row-2 {
          width: 100%;
          height: 50px;
          padding-top: 15px;
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;
          input {
            display: inline-block;
            border: none;
            width: 230px;
            margin-left: 44px;
            &::-webkit-input-placeholder {
              color: #cccccc;
              font-size: 16px;
              box-sizing: border-box;
              padding-top: 3px;
            }
          }
        }
        .write-info-row-3 {
          width: 100%;
          padding-top: 15px;
          box-sizing: border-box;
          input {
            border: none;
            margin-left: 30px;
            &::-webkit-input-placeholder {
              color: #cccccc;
              font-size: 16px;
              box-sizing: border-box;
              padding-top: 3px;
            }
          }
        }
      }
      // 第二个模块
      .write-info2 {
        width: 375px;
        height: 102px;
        padding: 0 13px;
        box-sizing: border-box;
        background-color: #ffffff;
        text-align: left;
        color: #333333;
        font-size: 15px;
        margin-top: 10px;
        .write-info-row-1 {
          width: 100%;
          height: 50px;
          padding-top: 15px;
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;
          input {
            border: none;
            margin-left: 33px;
            &::-webkit-input-placeholder {
              color: #cccccc;
              font-size: 16px;
              box-sizing: border-box;
              padding-top: 3px;
            }
            &:disabled {
              background-color: #ffffff;
            }
          }
        }
        .write-info-row-2 {
          width: 100%;
          height: 50px;
          padding-top: 15px;
          box-sizing: border-box;
          input {
            // width: 70%;
            width: 226px;
            border: none;
            margin-left: 33px;
            &::-webkit-input-placeholder {
              color: #cccccc;
              font-size: 16px;
              box-sizing: border-box;
              padding-top: 3px;
            }
            &:disabled {
              background-color: #ffffff;
            }
          }
           .city-detail {
             display: inline-block;
             width: 250px;
             float: right;
          }
        }
    
      }
      // 第三个模块信息描述
      .write-info3 {
        width: 375px;
        // height: 100%;
        overflow-y: hidden;
        padding: 0 13px;
        box-sizing: border-box;
        background-color: #ffffff;
        text-align: left;
        color: #333333;
        font-size: 15px;
        margin-top: 10px;
        .title {
          text-align: left;
          padding: 18px 0;
          box-sizing: border-box;
          .prompt {
            color: #999999;
            font-size: 13px;
          }
        }
        .textarea {
          width: 100%;
          height: 100%;
          textarea {
            background-color: #eaeaea;
            width: 349px;
            height: 100px;
            border: none;
            border-radius: 8px;
            padding: 15px 10px;
            box-sizing: border-box;
            &::-webkit-input-placeholder {
              color: #999999;
            }
          }
        }
        //上传图片
        .van-uploader {
          margin-bottom: 20px;
        }
      }
      // 按钮
      .plbm-btn {
        width: 350px;
        height: 44px;
        background: -webkit-linear-gradient(left, #05aefc, #008cff);
        margin: 0 auto;
        border-radius: 22px;
        font-size: 16px;
        color: $white-color;
        line-height: 44px;
        margin: 37px auto;
      }
  }
}
</style>
<style lang="scss">
.van-uploader__preview {
  margin-left: 6px;
}
</style>